import { SkillsBarData } from "../../hooks/queries/insights/use_skills_bar_query";

const getRandomArbitrary = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min) + min);

export const mockDemandSupplyData = (data: SkillsBarData): SkillsBarData => ({
  ...data,
  bar: Array.isArray(data.bar)
    ? data.bar.map((item, index) => {
        let min = item.num_profiles * 0.5;
        let max = item.num_profiles * 1.5;
        if (Array.isArray(data.bar) && index === Math.floor(data.bar.length / 2)) {
          // they want a value to have much more roles than profiles
          min = item.num_profiles;
          max = item.num_profiles * 4;
        }
        return {
          ...item,
          num_roles: getRandomArbitrary(min, max)
        };
      })
    : []
});
